<template>
    <div style="width: 100%;" class="fooTer">
        <p data-v-145d6ce4="">Copyright (c) 2010 国家计算机网络应急技术处理协调中心 版权所有</p>
        <p data-v-145d6ce4="">京ICP备10012421号   Email：ics-cert@cert.org.cn</p>
<!--        <p data-v-145d6ce4="">技术支持：<a data-v-145d6ce4="" href="#" style="color: #fff;">信联科技（南京）有限公司</a></p>-->
    </div>
</template>

<script>
    export default {
        name: "footerPhone"
    }
</script>

<style scoped>
    .fooTer{
        background: url("../../assets/image/banner/footer.png") center center no-repeat;
        background-size: cover;
        padding: 12px 0;
    }
    .fooTer p{
        font-size: 10px;
        font-weight: 400;
        color: #dbdbdb;
        text-align: center;
        line-height: 14px;
        margin-bottom: 0px;
    }
</style>
